export default __webpack_public_path__ + "static/media/srcipt-active.06adf3dc.png";